import e, { Component as t } from "react";
import { componentName as i } from "../../../utils/bem/index.js";
import { GlobalListener as o } from "../../offscreen/GlobalListener/GlobalListener.js";
import { Icon as n } from "../../general/Icon/Icon.js";
import { VideoCard as a } from "./components/VideoCard.js";
import { t as r } from "../../../i18/index.js";
import { AutoComplete as s } from "../../forms/AutoComplete/AutoComplete.js";
import "../../forms/AutoComplete/AutoCompletePanel.js";
import { SingleVideoView as l } from "./components/SingleVideoView.js";
import { InAppSidebar as d, findIframes as c } from "./components/InAppSidebar.js";
import u from "../../../../node_modules/classnames/index.js";
import { tip as p } from "../../forms/Tooltip/Tooltip.js";
function h(e) {
  if (void 0 === e) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function f(e, t) {
  for (var i = 0; i < t.length; i++) {
    var o = t[i];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
  }
}
function m(e, t, i) {
  return t in e ? Object.defineProperty(e, t, {
    value: i,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = i, e;
}
function g(e) {
  return (g = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  })(e);
}
function v(e, t) {
  return (v = Object.setPrototypeOf || function (e, t) {
    return e.__proto__ = t, e;
  })(e, t);
}
var V = function (t) {
  !function (e, t) {
    if ("function" != typeof t && null !== t) throw TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        writable: !0,
        configurable: !0
      }
    }), t && v(e, t);
  }(k, t);
  var V,
    b,
    y,
    S = (V = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (e) {
        return !1;
      }
    }(), function () {
      var e,
        t,
        i = g(k);
      if (V) {
        var o = g(this).constructor;
        t = Reflect.construct(i, arguments, o);
      } else t = i.apply(this, arguments);
      return (e = t) && ("object" == (e && "undefined" != typeof Symbol && e.constructor === Symbol ? "symbol" : typeof e) || "function" == typeof e) ? e : h(this);
    });
  function k() {
    var e;
    return !function (e, t) {
      if (!(e instanceof t)) throw TypeError("Cannot call a class as a function");
    }(this, k), e = S.apply(this, arguments), m(h(e), "state", {
      selectedVideo: null,
      filteredData: null,
      filteredDataSidebar: null,
      singleVideoView: !1,
      active: !1,
      item: null,
      searchTagsOnSidebar: !1,
      singleVideo: null,
      singleVideoIndex: null,
      tooltipsList: null
    }), m(h(e), "tooltip", void 0), m(h(e), "handleClick", function (t) {
      var i, o, n, a;
      null === (i = (o = e.props).onClick) || void 0 === i || i.call(o, t), null === (n = (a = e.props).onClose) || void 0 === n || n.call(a);
    }), m(h(e), "handleClickBackground", function (t) {
      var i, o, n, a;
      null === (i = (o = e.props).onClick) || void 0 === i || i.call(o, t), "kaseya-ui-in-app-videos" === t.target.className && (null === (n = (a = e.props).onClose) || void 0 === n || n.call(a));
    }), m(h(e), "handleVideoClick", function (t, i, o) {
      var n, a;
      null === (n = (a = e.props).onClick) || void 0 === n || n.call(a, t), e.props.supportSingleVideoView && e.setState({
        singleVideoView: !0,
        singleVideo: i,
        singleVideoIndex: o
      });
    }), m(h(e), "handleReturn", function (t) {
      var i, o;
      null === (i = (o = e.props).onClick) || void 0 === i || i.call(o, t), e.setState({
        singleVideoView: !1
      });
    }), m(h(e), "handleEsc", function () {
      var t, i, o, n;
      null === (t = (i = e.props).onEsc) || void 0 === t || t.call(i), null === (o = (n = e.props).onClose) || void 0 === o || o.call(n);
    }), m(h(e), "handleEnter", function () {
      var t, i;
      null === (t = (i = e.props).onEnter) || void 0 === t || t.call(i);
    }), m(h(e), "handleMouseDown", function (e) {
      e.stopPropagation();
    }), m(h(e), "timer", void 0), m(h(e), "handleClickSidebar", function (t) {
      var i, o;
      if (null === (i = (o = e.props).onClick) || void 0 === i || i.call(o, t), t.target) {
        var n = e.doSearchSidebar(t.target.textContent);
        e.setState({
          filteredDataSidebar: n,
          filteredData: n,
          selectedVideo: null
        });
      }
    }), m(h(e), "handleClickSingleVideo", function (t) {
      (t.ctrlKey || 1 === t.button) && window.open(e.state.singleVideo.link, "_blank");
    }), m(h(e), "handleClickSearchClear", function () {
      e.setState({
        selectedVideo: null
      });
    }), m(h(e), "searchVideoData", function (t) {
      e.timer && clearTimeout(e.timer), e.timer = setTimeout(function () {
        return e.doSearch(t);
      }, 100);
    }), e;
  }
  return b = [{
    key: "doSearch",
    value: function value(e) {
      var t,
        i = this,
        o = [];
      t = this.state.filteredDataSidebar ? this.state.filteredDataSidebar : this.props.dataVimeo, e.query.trim().length && (o = t.filter(function (t) {
        return t.name.toLowerCase().includes(e.query.toLowerCase()) || i.doSearchTag(e.query.toLowerCase(), t);
      })), this.setState({
        filteredData: o,
        searchTagsOnSidebar: !1
      });
    }
  }, {
    key: "doSearchTag",
    value: function value(e, t) {
      return t.tags.findIndex(function (t) {
        return t.toLowerCase().includes(e.trim().toLowerCase());
      }) >= 0;
    }
  }, {
    key: "doSearchSidebar",
    value: function value(e) {
      var t = this.props.dataVimeo.filter(function (t) {
        return t.tags.includes(e.trim());
      });
      return e.includes("All") ? (this.setState({
        searchTagsOnSidebar: !1,
        active: !0,
        item: e
      }), this.props.dataVimeo) : (this.setState({
        searchTagsOnSidebar: !0
      }), this.setState({
        active: !0,
        item: e
      }), t);
    }
  }, {
    key: "filterVideoData",
    value: function value() {
      return !this.state.selectedVideo && this.state.filteredDataSidebar ? this.state.filteredDataSidebar : this.state.selectedVideo ? this.state.filteredData : this.props.dataVimeo;
    }
  }, {
    key: "getUniqueTags",
    value: function value() {
      var e,
        t = new Set();
      return null === (e = this.props.dataVimeo) || void 0 === e || e.map(function (e) {
        for (var i in e.tags) t.add(e.tags[i]);
      }), Array.from(t).filter(function (e) {
        return "Suggested" !== e;
      });
    }
  }, {
    key: "getVideosAndTags",
    value: function value(e, t) {
      var i = [];
      return e.forEach(function (e) {
        var o = 0,
          n = 0;
        t.forEach(function (t) {
          t.tags.includes("Suggested") && t.tags.filter(function (e) {
            return "Suggested" !== e;
          }).toString().includes(e) && o <= 2 && (o += 1, i.push({
            tag: e,
            index: n,
            video: t
          })), n += 1;
        });
      }), i;
    }
  }, {
    key: "componentDidMount",
    value: function value() {
      this.renderTooltip();
    }
  }, {
    key: "componentDidUpdate",
    value: function value(e, t) {
      (t.filteredData !== this.state.filteredData || t.singleVideoView !== this.state.singleVideoView) && (this.destroyTooltip(), this.renderTooltip());
    }
  }, {
    key: "componentWillUnmount",
    value: function value() {
      this.destroyTooltip();
    }
  }, {
    key: "destroyTooltip",
    value: function value() {
      var e;
      null === (e = this.state.tooltipsList) || void 0 === e || e.forEach(function (e) {
        e.destroy(), e = null;
      }), this.setState({
        tooltipsList: null
      });
    }
  }, {
    key: "renderTooltip",
    value: function value() {
      var e = this,
        t = [],
        i = document.querySelectorAll(".itg-video__title"),
        o = this.filterVideoData() || this.props.dataVimeo;
      i.forEach(function (i, n) {
        var a;
        (null === (a = i.innerHTML) || void 0 === a ? void 0 : a.length) >= 42 && (e.tooltip = p({
          target: i,
          content: o[n].name,
          options: {
            position: "bottom"
          }
        }), t.push(e.tooltip));
      }), this.setState({
        tooltipsList: t
      });
    }
  }, {
    key: "render",
    value: function value() {
      var t = this,
        p = i("in-app-videos", this.props.className),
        h = this.filterVideoData() || this.props.dataVimeo,
        f = this.getUniqueTags(),
        g = null == h ? void 0 : h.length,
        v = this.getVideosAndTags(f, this.props.dataVimeo),
        V = this.props.singleVideoViewSidebar ? "" : "single",
        b = u("in-app-videos__lower-inner-body", V),
        y = u("in-app-videos__lower-body", V),
        S = u("in-app-videos__body", V);
      return e.createElement("div", {
        className: p,
        onMouseDown: this.handleMouseDown,
        onClick: this.handleClickBackground
      }, e.createElement(o, {
        types: "keydown",
        onEnter: this.handleEnter,
        onEsc: this.handleEsc
      }), e.createElement("div", {
        className: "in-app-videos__inner-container"
      }, e.createElement("div", {
        className: "in-app-videos__header"
      }, e.createElement("div", {
        className: "in-app-videos__title"
      }, " ", r("video-tutorials"), e.createElement(n, {
        light: !0,
        name: "times",
        className: "dialog__close-button",
        onClick: this.handleClick
      }))), e.createElement("div", {
        className: y
      }, this.props.sidebar && (this.props.singleVideoViewSidebar && v || !this.state.singleVideoView) && e.createElement(d, {
        tags: f,
        tagColors: this.props.tagColors,
        singleVideoView: this.state.singleVideoView,
        handleReturn: this.handleReturn,
        active: this.state.active,
        item: this.state.item,
        size: this.state.singleVideoView,
        dataVimeo: this.props.dataVimeo,
        handleClickSidebar: this.handleClickSidebar,
        handleVideoClick: this.handleVideoClick,
        videosAndTags: v
      }), this.state.singleVideoView && this.props.supportSingleVideoView ? e.createElement("div", {
        className: "in-app-videos__single-video-view"
      }, e.createElement(l, {
        key: 1,
        onClick: function onClick(e) {
          return t.handleClickSingleVideo(e);
        },
        onClickReturn: this.handleReturn,
        title: this.state.singleVideo.name,
        date: this.state.singleVideo.date,
        link: this.state.singleVideo.link,
        tag: this.state.singleVideo.tags,
        tagColors: this.props.tagColors,
        singleVideoSidebar: this.props.singleVideoViewSidebar,
        iframe: c(this.state.singleVideoIndex, this.props.dataVimeo, !0),
        description: this.state.singleVideo.description
      })) : e.createElement("div", {
        className: "single-video-view-none"
      }), !this.state.singleVideoView && e.createElement("div", {
        className: b
      }, e.createElement("div", {
        className: "in-app-videos__search-bar"
      }, e.createElement("div", {
        className: "search-container-in-app"
      }, e.createElement(s, function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var i = null != arguments[t] ? arguments[t] : {},
            o = Object.keys(i);
          "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(i).filter(function (e) {
            return Object.getOwnPropertyDescriptor(i, e).enumerable;
          }))), o.forEach(function (t) {
            m(e, t, i[t]);
          });
        }
        return e;
      }({
        value: this.state.selectedVideo,
        completeMethod: this.searchVideoData,
        field: "name",
        placeholder: r("itc-searchbar-placeholder"),
        onChange: function onChange(e) {
          return t.setState({
            selectedVideo: e.value
          });
        },
        autoFocus: !0
      }, this.props)), !this.state.selectedVideo && e.createElement(n, {
        regular: !0,
        name: "search",
        className: "dropdown-filter-icon-in-app-videos"
      }), this.state.selectedVideo && e.createElement(n, {
        light: !0,
        name: "times",
        onClick: function onClick() {
          return t.handleClickSearchClear();
        },
        className: "dialog__close-button-search"
      })), e.createElement("span", {
        className: "in-app-videos__results"
      }, " ", r("video-results", {
        dataLength: g
      }))), h && !this.state.singleVideoView && e.createElement("div", {
        className: S
      }, h.map(function (i, o) {
        return e.createElement("div", {
          className: "itc-videos",
          key: o
        }, e.createElement(a, {
          key: o,
          className: "itg-video",
          title: i.name,
          onClick: function onClick(e) {
            return t.handleVideoClick(e, i, o);
          },
          iframe: c(o, t.props.dataVimeo, !1),
          sidebar: t.props.sidebar,
          tags: i.tags,
          tagColors: t.props.tagColors,
          description: i.description
        }));
      }))))));
    }
  }], f(k.prototype, b), y && f(k, y), k;
}(t);
m(V, "defaultProps", {
  sidebar: "True",
  supportSingleVideoView: "True",
  singleVideoViewSidebar: "True"
});
export { V as InAppVideos };